import React from 'react';
import { Shield, Mail, Building2, Calendar } from 'lucide-react';
import PageLayout from '../../components/Layout/PageLayout';
import PageHeader from '../../components/PageHeader/PageHeader';
// Reuse the shared legal-page styling from the Terms page
import '../TermsPage/ModernTermsPage.scss';

const ModernPrivacyPage = () => {
    const privacyData = [
        {
            title: 'DATA CONTROLLER & DATA COLLECTION',
            content: [
                'Jaak Tech is committed to safeguarding your privacy. The types of Personal Data collected may vary depending on the services offered and may be voluntarily provided by users or automatically collected when using this site. This data may include but is not limited to user-provided information, cookies, and other tracking tools. Cookies are used solely to improve the user experience and personalize service offerings.',
                'Certain types of data may be necessary to access and utilize specific features or services on this website. For example, contact information, account details, or preferences may be required to personalize the experience or enable specific functionalities.',
            ],
        },
        {
            title: 'USER RESPONSIBILITIES',
            content: [
                'Users are responsible for any third-party data shared via Jaak Tech and affirm their rights to communicate such data, thereby relieving Jaak Tech of any associated liability.',
            ],
        },
        {
            title: 'DATA PROCESSING & SECURITY',
            content: [
                "Data is processed using secure IT systems at Jaak Tech's operational offices and in other locations necessary to support our services. Jaak Tech ensures strict security measures to prevent unauthorized access, modification, or destruction of personal data. In some cases, data may be accessed by select team members (e.g., sales, marketing, system administration) or external parties (e.g., service providers), as authorized by Jaak tech Tech.",
            ],
        },
        {
            title: 'DATA STORAGE & RETENTION',
            content: [
                'Personal data is retained only for as long as necessary to fulfill the intended purpose or as required by law. Users may request data deletion or suspension at any time by contacting Jaak Tech.',
            ],
        },
        {
            title: 'LEGAL ACTION',
            content: [
                'Jaak Tech may disclose personal data to comply with legal obligations or respond to public authority requests. Personal data may also be used in legal proceedings arising from improper use of the website or services.',
            ],
        },
        {
            title: 'USER RIGHTS',
            content: [
                'Users have the right to access, update, or delete their personal data and may contact Jaak Tech at any time for assistance. Users can also request data anonymization or oppose processing activities under applicable laws. Such requests should be directed to the Data Controller using the contact details provided on this page.',
            ],
            list: [
                'Request information about the personal data Jaak tech Tech holds.',
                'Correct any inaccurate or incomplete data.',
                "Request the deletion of their data when it's no longer needed.",
                'Request their data in a transferable format.',
                'Limit the processing of their data in certain situations.',
                'Object to the processing of their data for direct marketing or legitimate interests.',
                'Withdraw consent for data processing at any time.',
                'File a complaint with a supervisory authority if they feel their rights are violated.',
            ],
        },
        {
            title: '"DO NOT TRACK" REQUESTS',
            content: [
                'Jaak Tech does not currently support "Do Not Track" requests. For information on how third-party services handle such requests, please refer to their respective privacy policies.',
            ],
        },
        {
            title: 'POLICY UPDATES',
            content: [
                'Jaak Tech may update this Privacy Policy periodically. Users are encouraged to review this page regularly. Continued use of the website constitutes acceptance of these terms.',
            ],
        },
        {
            title: 'RETARGETING & AD COOKIES',
            content: [
                'Jaak Tech uses cookies for advertising purposes through partners like AdRoll. While these partners do not collect sensitive personal information, cookies allow for tailored advertising based on user interests. Users can opt out of targeted advertising through the Network Advertising Initiative.',
            ],
        },
    ];

    return (
        <PageLayout>
            <PageHeader
                title="Privacy Policy"
                subtitle="Jaak Tech privacy policy - your access and usage rights"
                breadcrumbs={[{ label: 'Privacy Policy' }]}
            />

            {/* Meta */}
            <section className="jk-terms-meta">
                <div className="jk-terms-meta__container">
                    <div className="jk-terms-meta__badge">
                        <Shield size={18} />
                        <span>Privacy Policy</span>
                    </div>
                    <div className="jk-terms-meta__date">
                        <Calendar size={18} />
                        <span>Updated on: May 10th, 2026</span>
                    </div>
                </div>
            </section>

            {/* Content */}
            <section className="jk-terms-content">
                <div className="jk-terms-content__container">
                    {privacyData.map((section, index) => (
                        <div key={index} className="jk-terms-section">
                            <h2 className="jk-terms-section__title">
                                <span className="jk-terms-section__number">{index + 1}.</span>
                                {section.title}
                            </h2>
                            <div className="jk-terms-section__content">
                                {section.content.map((item, itemIndex) => (
                                    <p key={itemIndex} className="jk-terms-section__item">
                                        {item}
                                    </p>
                                ))}
                                {section.list && (
                                    <ul className="jk-terms-section__list">
                                        {section.list.map((item, itemIndex) => (
                                            <li key={itemIndex}>{item}</li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </div>
                    ))}

                    {/* Contact Section */}
                    <div className="jk-terms-contact">
                        <div className="jk-terms-contact__icon">
                            <Mail size={24} />
                        </div>
                        <h2 className="jk-terms-contact__title">Contact Information</h2>
                        <p className="jk-terms-contact__text">
                            For questions regarding this Privacy Policy, to exercise your data rights, or for other
                            related issues, please contact us:
                        </p>
                        <div className="jk-terms-contact__details">
                            <div className="jk-terms-contact__item">
                                <strong>Email:</strong>
                                <a href="mailto:info@jaaktech.net">info@jaaktech.net</a>
                            </div>
                            <div className="jk-terms-contact__address">
                                <Building2 size={20} />
                                <div>
                                    <strong>Jaak Tech</strong>
                                    <span>3342 Bladensburg Rd, Suite B06</span>
                                    <span>Brentwood, Maryland 20722</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </PageLayout>
    );
};

export default ModernPrivacyPage;
